<celum-message-dialog [config]="messageDialogConfig">
  <div class="celum-format-change-warning_checkbox">
    <mat-checkbox [(ngModel)]="dontShowAgain" [labelPosition]="'before'">
      <span>{{ 'CHANGE_WARNING.DIALOG.DONT_SHOW_AGAIN' | translate }}</span>
    </mat-checkbox>
  </div>
</celum-message-dialog>
